import styled from 'styled-components'
import { GRAYSCALE_200, VIOLET_600, WHITE } from '../../styles/colors'

interface SwitchTrackProps {
  $isActive: boolean
}

export const SwitchTrack = styled.div<SwitchTrackProps>`
  position: relative;
  width: 52px;
  height: 32px;
  border-radius: 16px;
  background-color: ${({ $isActive }) => ($isActive ? VIOLET_600 : GRAYSCALE_200)};
  transition: background-color 0.2s ease;
  cursor: pointer;
` as any

export const SwitchThumb = styled.div<{ $isActive: boolean }>`
  position: absolute;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${WHITE};
  top: 4px;
  left: ${({ $isActive }) => ($isActive ? 'calc(100% - 28px)' : '4px')};
  transition: left 0.2s ease;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
` as any

export const SwitchContainer = styled.div`
  display: inline-flex;
  align-items: center;
`

export const SwitchLabel = styled.span`
  margin-right: 12px;
  font-size: 16px;
`
